import { useState } from "react";
import { ConfigProvider, Input, Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";

interface AddPhotoModalPropsI {
  open: boolean;
  onClose: () => void;
  onConfirm: (name: string) => void;
}

// Modal que pide el nombre de una foto extra antes de agregarla
export const AddPhotoModal = ({
  open,
  onClose,
  onConfirm,
}: AddPhotoModalPropsI) => {
  const [newName, setNewName] = useState("");

  const closeModal = () => {
    setNewName("");
    onClose();
  };

  const confirmAdd = () => {
    const name = newName.trim();
    if (!name) return;
    onConfirm(name);
    closeModal();
  };

  return (
      <ConfigProvider
        theme={{
          token: { colorPrimary: "#030521", borderRadius: 8 },
          components: {
            Modal: { headerBg: "#030521", titleColor: "#ffffff" },
            Button: { colorPrimaryHover: "#1b1f4a" },
          },
        }}
      >
        <Modal
          title={
            <span
              style={{
                color: "#fff",
                fontWeight: 700,
                letterSpacing: 1,
                textTransform: "uppercase",
                fontSize: 14,
              }}
            >
              Agregar foto
            </span>
          }
          open={open}
          onOk={confirmAdd}
          onCancel={closeModal}
          okText="Agregar"
          cancelText="Cancelar"
          okButtonProps={{ disabled: !newName.trim(), size: "large" }}
          cancelButtonProps={{ size: "large" }}
          closeIcon={<CloseOutlined style={{ color: "#fff" }} />}
          centered
          width={420}
          destroyOnClose
          styles={{
            content: { padding: 0, overflow: "hidden" },
            header: {
              background: "#030521",
              margin: 0,
              padding: "16px 24px",
            },
            body: { padding: "20px 24px 4px" },
            footer: { padding: "12px 24px 20px", margin: 0 },
          }}
        >
          <p
            style={{
              margin: "0 0 8px",
              fontSize: 12,
              fontWeight: 600,
              color: "#030521",
            }}
          >
            Nombre de la foto
          </p>
          <Input
            autoFocus
            size="large"
            placeholder="Ej: Foto precinto lateral"
            value={newName}
            maxLength={100}
            showCount
            onChange={(e) => setNewName(e.target.value)}
            onPressEnter={confirmAdd}
          />
        </Modal>
      </ConfigProvider>
  );
};
